import { apiAuth } from "../../http";

export const postHighLight = async (body: any): Promise<any> => {
  const response = apiAuth()
    .post("/highlights", body)
    .then(({ data }) => data);
  return response;
};
